import _ from 'lodash';

import {
  differenceInCalendarYears,
  formatDate,
  getMonthIndex,
  getMonthName,
  getYear,
  sub,
} from 'components/helpers/dates';

export function generateMonthsMap(startMonth = 1, endMonth = 12) {
  return _.range(startMonth, endMonth + 1).reduce((obj, month) => {
    obj[month] = { count: 0, deletedCount: 0 };

    return obj;
  }, {});
}

export function generateChartProps({ report }) {
  const chartProps = {};
  const countsIndexedByDateRange = {};

  (function initialiseChartProps() {
    const today = new Date();

    switch (report.data.attributes.dateRange) {
      case 'this_year':
        {
          const currentYear = getYear({ date: today });
          countsIndexedByDateRange[currentYear] = generateMonthsMap();
          chartProps.xAxisLabel = currentYear;
        }
        break;
      case 'last_year':
        {
          const lastYear = getYear({
            date: sub({ date: today, durationParts: { years: 1 } }),
          });

          countsIndexedByDateRange[lastYear] = generateMonthsMap();
          chartProps.xAxisLabel = lastYear;
        }
        break;
      case 'all_time':
        {
          const earliestDate = report.meta.accountCreatedAt;

          const yearsDiff = differenceInCalendarYears({
            earlierDate: earliestDate,
            laterDate: today,
          });

          for (let i = 0; i <= yearsDiff; i++) {
            const startingMonth =
              i === yearsDiff ? getMonthIndex({ date: earliestDate }) + 1 : 1;

            const endingMonth =
              i === 0 ? getMonthIndex({ date: today }) + 1 : 12;

            const yearInScope = getYear({
              date: sub({ date: today, durationParts: { years: i } }),
            });

            countsIndexedByDateRange[yearInScope] = generateMonthsMap(
              endingMonth,
              startingMonth,
            );
          }

          chartProps.xAxisLabel = `${formatDate({ date: earliestDate, format: 'MMM yyyy' })} - ${formatDate({ date: today, format: 'MMM yyyy' })}`;
        }
        break;
    }
  })();

  (function populateCountsIndexFromReport() {
    report.data.attributes.countBreakdown.forEach((rangeData) => {
      countsIndexedByDateRange[rangeData.year_range][rangeData.month_range] = {
        deletedProjectCount: rangeData.deleted_project_count,
        projectCount: rangeData.project_count,
      };
    });
  })();

  chartProps.data = (function constructDataFromProjectsCountIndex() {
    return Object.entries(countsIndexedByDateRange).reduce(
      (data, yearRange) => {
        const [year, monthCounts] = yearRange;

        Object.entries(monthCounts).forEach((monthRange) => {
          const [month, counts] = monthRange;

          data.push({
            count: counts.projectCount,
            countKey: `${year}${month}`,
            deletedCount: counts.deletedProjectCount,
            name: getMonthName({ monthIndex: month - 1, width: 'abbreviated' }),
            yearMonth: `${year}-${('0' + month).slice(-2)}`,
          });
        });

        return data;
      },
      [],
    );
  })();

  return chartProps;
}

export const defaultChartProps = { data: [], xAxisLabel: undefined };
